import React, { useState } from 'react';
import { Newspaper } from 'lucide-react';
import { fileUrl } from '../lib/api';

/**
 * Image that never shows the browser's broken-image icon.
 *
 * - While loading / on success: a normal <img>.
 * - On error (file missing from storage, bad URL): renders a quiet branded
 *   placeholder of the same size (mode="placeholder") or nothing at all
 *   (mode="hide"), so the layout stays tidy and readers are not shown a
 *   broken picture. The failure is also reported through onFail for
 *   diagnostics.
 */
export const SafeImage = ({ src, alt = '', className = '', mode = 'placeholder', placeholderClassName = '', onFail, testid, ...rest }) => {
  const [failed, setFailed] = useState(false);
  const resolved = src ? fileUrl(src) : '';
  if (!resolved) return null;
  if (failed) {
    if (mode === 'hide') return null;
    return (
      <div
        role="img"
        aria-label={alt || 'Image unavailable'}
        data-testid={testid ? `${testid}-fallback` : undefined}
        className={`flex items-center justify-center bg-[#EAF2FF] text-[#24406f] ${placeholderClassName || className}`}
      >
        <Newspaper className="h-7 w-7 opacity-60" aria-hidden="true" />
      </div>
    );
  }
  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      data-testid={testid}
      loading="lazy"
      onError={() => { setFailed(true); if (onFail) onFail(src); }}
      {...rest}
    />
  );
};

export default SafeImage;
